import $ from 'jquery';
import { UserManagedList as uml } from 'App/user-managed-list/user-managed-list';
import fileIO from 'Util/fileio';
import Mustache from 'mustache';
import { publish, subscribe } from 'Util/pubsub';

const selectors = {
	basket: '.js-basket',
	basketCount: '.js-basket__count',
	basketTitle: '.js-basket__title',
	basketList: '.js-basket__list',
	basketItem: '.js-basket__item',
	basketHeader: '.js-basket-header',

	basketItemReference: '.js-basket__item-reference',
	basketItemTemplate: '#basket-item-template',
	basketSource: '.js-basket-source',

	basketDownloadAll: '.js-basket__download-all',

	resourceItem: '.js-resources__item',
	resourceDownload: '.js-resources__download',
	resourceToggle: '.js-toggle-resources-item',

	resourceFileContainer: '.js-resources__file-container',
	resourceFile: '.js-resources__file',
	resourceFileType: '.js-resources__file-type',

	resourceTitle: '.js-resources__title'
};

const dataSelectors = {
	basketReferenceName: 'basket-reference-name',
	basketReferenceId: 'basket-reference-id',
	basketDownloadError: 'basket-download-error',

	resourceDownloadError: 'resources-download-error',

	umlId: 'uml-id'
};

const classes = {
	loader: 'o-loader'
};

const api = {
	download: '/download-zip'
};

const publications = {
	success: '/status/success',
	error: '/status/error',

	umlAdd: '/uml/local/add',
	umlRemove: '/uml/local/remove'
};
const subscriptions = {
	umlAdded: '/uml/local/added',
	umlRemoved: '/uml/local/removed'
};

const listIds = {
	basket: 'basket'
};

const Types = {
	SINGLE: 'single'
};

const States = {
	ENABLED: 'enabled',
	DISABLED: 'disabled'
};

const module = {
	init: {
		init() {
			module.init._initEvents();
			module.init._initSubscriptions();
			module.init._initButtonStates();
			module.init._initBasketStatus();
			module.basket._updateCount();
		},

		_initEvents() {
			$(selectors.resourceDownload).on('click', module.resources.downloadEvent);
			$(selectors.resourceToggle).on('click', module.resources.toggleEvent);
			$(document).on('click', selectors.basketDownloadAll, module.basket.downloadAllEvent);

			$(document).on('click', selectors.basketHeader, function () {
				$(selectors.basket).toggleClass('is-showing');
			});
		},

		_initSubscriptions() {
			subscribe(subscriptions.umlAdded, module.basket.addItems);
			subscribe(subscriptions.umlRemoved, module.basket.removeItems);
			subscribe(subscriptions.umlAdded, module.resources._refreshAllToggleAddRemoveStates);
			subscribe(subscriptions.umlRemoved, module.resources._refreshAllToggleAddRemoveStates);
		},

		_initButtonStates() {
			const ids = uml.localStorage.getList(listIds.basket);
			const $basketSource = $(selectors.basketSource);

			// Filter children that are in the basket
			$basketSource.children().each((i, el) => {
				const $child = $(el);
				const refId = $child.data(dataSelectors.basketReferenceId);
				const $toggle = $child.find(selectors.resourceToggle);

				if (ids.includes(refId)) {
					$child.find($toggle).attr('aria-pressed', true);
				}
			});
		},

		_initBasketStatus() {
			const $list = $(selectors.basketList);
			const listId = 'basket';
			const ids = uml.localStorage.getList(listId);
			const $basketSource = $(selectors.basketSource);
			const items = [];

			ids.forEach(id => {
				const $resource = $basketSource.children().filter(function () {
					return $(this).data('basket-reference-id') == id;
				}).first();

				if ($resource.length) {
					items.push({
						Name: $resource.data('basket-reference-name'),
						Id: id
					});
				}
			});

			// Render and append to the list
			const $template = $('#basket-item-template');
			if (items.length) {
				items.forEach(item => module.basket._insertItem(item.Id));

			} else {
				uml.update.showPlaceholderIfListEmptySubscription(listId);
			}

			// Show/hide placeholder as appropriate
			//module.update.showPlaceholderIfListEmpty($list, ids);
			//module.cache.create($list);
		}
	},

	basket: {
		addItems(listId, ids) {
			if (listId !== listIds.basket) return;
			if (!Array.isArray(ids)) ids = [ids];
			module.basket._updateCount();
			ids.forEach(id => module.basket._insertItem(id));
		},

		_insertItem(id) {
			module.basket._insertSingleItem(id);
		},

		_getIdType(id) {
			return /\|/.test(id) ? Types.COMPOUND : Types.SINGLE;
		},

		_insertSingleItem(id) {
			const itemHtml = module.basket._buildSingleItemHtml(id);
			if (itemHtml) {
				const $newItem = $(itemHtml);
				const $list = $(selectors.basketList);
				$list.prepend($newItem);
			}
		},

		_buildSingleItemHtml(id) {
			const $template = $(selectors.basketItemTemplate);
			const template = $template.html();
			if (!template) return;
			const itemData = module.basket._getSingleItemReferenceData(id);
			if (itemData) {
				return Mustache.render(template, itemData);
			}
		},

		_getSingleItemReferenceData(id) {
			const $reference = module.basket._getItemReference(id);
			if ($reference.length) {
				return {
					Name: $reference.data(dataSelectors.basketReferenceName),
					Id: $reference.data(dataSelectors.basketReferenceId)
				};
			}
		},

		_getItemReference(id) {
			const $itemReferences = $(selectors.basketItemReference);
			return $itemReferences.filter(module.basket._byReferenceId(id)).first();
		},

		_getFileReference($reference, fileId) {
			const $files = $reference.find(selectors.resourceFile);
			return $files.filter(module.basket._byReferenceId(fileId)).first();
		},

		_byReferenceId(id) {
			id = id + '';
			return function (i, el) {
				const $el = $(el);
				const elId = $el.data(dataSelectors.basketReferenceId) + '';
				return elId === id;
			};
		},

		removeItems(listId, ids) {
			if (listId !== listIds.basket) return;
			if (!Array.isArray(ids)) ids = [ids];
			module.basket._updateCount();
			ids.forEach(id => module.basket._removeItem(id));
		},

		_removeItem(id) {
			const $items = $(selectors.basketItem);
			const $matchingItems = $items.filter(module.basket._byUmlId(id));
			$matchingItems.remove();
		},

		_byUmlId(id) {
			return function (i, el) {
				const $el = $(el);
				const elId = $el.data(dataSelectors.umlId);
				return elId === id;
			};
		},

		_updateCount() {
			const basket = uml.localStorage.getList(listIds.basket);
			const count = basket.length;
			const $basketCount = $(selectors.basketCount);
			$basketCount.text(count > 0 ? count : '');
			$basketCount.toggleClass('is-visible', count > 0);
			$('.js-basket__go').toggle(count > 0);
		},

		downloadAllEvent(e) {
			const $basket = $(e.target).closest(selectors.basket);
			module.basket._downloadAll($basket);
		},

		_downloadAll($basket) {
			const $files = $basket.find(selectors.basketItem);
			const mediaIds = [];
			for (let i = 0; i < $files.length; i++) {
				let id = $files.eq(i).data(dataSelectors.umlId) + '';
				const idSplit = id.match(/(.+)\|(.+)/);
				if (idSplit) {
					id = idSplit[2];
				}
				mediaIds.push(id);
			}
			const filename = module.basket._getFilename($basket);

			const request = new XMLHttpRequest();
			request.open('GET', api.download + '/' + mediaIds, true);
			request.responseType = 'arraybuffer';
			request.onload = module.basket._handleDownloadAllResponse(request, $basket, filename);
			request.send();
		},

		_getFilename($basket) {
			const title = 'basket';
			const date = new Date();
			const year = date.getFullYear();
			let month = date.getMonth() + 1;
			let day = date.getDate();
			if (month < 10) month = '0' + month;
			if (day < 10) day = '0' + day;
			const datestring = year + '-' + month + '-' + day;

			return `${title}-${datestring}.zip`;
		},

		_handleDownloadAllResponse(request, $basket, filename) {
			return function () {
				module.basket._downloadAllComplete($basket);
				if (request.status === 200) {
					module.basket._downloadAllSuccess(filename, request);
				} else {
					module.basket._downloadAllError($basket, request);
				}
			};
		},

		_downloadAllComplete($basket) {
			$basket.removeClass(classes.loader);
			$basket.find(selectors.basketDownloadAll).prop('disabled', false);
		},

		_downloadAllSuccess(filename, request) {
			fileIO.save.data(request.response, filename, 'application/x-zip-compressed');
		},

		_downloadAllError($basket) {
			const errorMessage = $basket.data(dataSelectors.basketDownloadError);
			publish(publications.error, errorMessage);
		}
	},

	resources: {
		downloadEvent(e) {
			e.preventDefault();
			const $item = $(e.target).closest(selectors.resourceItem);
			module.resources._download($item);
		},

		_download($item) {
			const files = module.resources._getSelectedFiles($item);
			const mediaIds = module.resources._getMediaIdList(files);
			const filename = module.resources._getFilename($item);
			$item.addClass(classes.loader);
			module.resources._setDownloadDisabledState($item, States.DISABLED);
			module.resources._setFileDisabledState($item, States.DISABLED);

			const request = new XMLHttpRequest();
			request.open('GET', api.download + '/' + mediaIds, true);
			request.responseType = 'arraybuffer';
			request.onload = module.resources._handleDownloadResponse(request, $item, filename);
			request.send();
		},

		_handleDownloadResponse(request, $item, filename) {
			return function () {
				module.resources._downloadComplete($item);
				if (request.status === 200) {
					module.resources._downloadSuccess(filename, request);
				} else {
					module.resources._downloadError($item);
				}
			};
		},

		_downloadComplete($item) {
			$item.removeClass(classes.loader);
			module.resources._setDownloadDisabledState($item, States.ENABLED);
			module.resources._setFileDisabledState($item, States.ENABLED);
		},

		_downloadSuccess(filename, request) {
			fileIO.save.data(request.response, filename, 'application/x-zip-compressed');
		},

		_downloadError($item) {
			const errorMessage = $item.data(dataSelectors.resourceDownloadError);
			publish(publications.error, errorMessage);
		},

		toggleEvent(e) {
			e.preventDefault();
			const $toggle = $(e.target).closest(selectors.resourceToggle);
			const $item = $toggle.closest(selectors.resourceItem);
			module.resources._toggle($item);
		},

		_toggle($item) {
			const $toggle = $item.find(selectors.resourceToggle);
			const files = module.resources._getSelectedFiles($item);
			const list = uml.localStorage.getList(listIds.basket);
			let action;
			if ($toggle.attr('aria-pressed') === 'true') {
				action = publications.umlRemove;
			} else {
				action = publications.umlAdd;
			}
			files.forEach(file => {
				if (action === publications.umlAdd && list.indexOf(file) !== -1) {
					return;
				}
				publish(action, [listIds.basket, file]);
			});
		},

		_setFileDisabledState($item, state) {
			const $file = $item.find(selectors.resourceFile);
			$file.prop('disabled', state === States.DISABLED);
		},

		_setDownloadDisabledState($item, state) {
			const $download = $item.find(selectors.resourceDownload);
			$download.prop('disabled', state === States.DISABLED);
		},

		_setToggleDisabledState($item, state) {
			const $toggle = $item.find(selectors.resourceToggle);
			$toggle.prop('disabled', state === States.DISABLED);
		},

		_refreshToggleAddRemoveState($item) {
			const $toggle = $item.find(selectors.resourceToggle);
			const files = module.resources._getSelectedFiles($item);
			const list = uml.localStorage.getList(listIds.basket);
			let state;
			if (files.length === 0) {
				// No file checkboxes — use the toggle's own data-uml-id (e.g. product detail page)
				const umlId = $toggle.data(dataSelectors.umlId);
				state = umlId !== undefined ? list.indexOf(umlId + '') !== -1 : false;
			} else {
				for (let i = 0; i < files.length; i++) {
					if (list.indexOf(files[i]) === -1) {
						state = false;
						break;
					}
				}
				if (typeof state === 'undefined') {
					state = true;
				}
			}
			$toggle.attr('aria-pressed', state);
		},

		_refreshAllToggleAddRemoveStates() {
			const $toggles = $(selectors.resourceToggle);
			$toggles.each((i, el) => {
				const $el = $(el);
				const $item = $el.closest(selectors.resourceItem);
				module.resources._refreshToggleAddRemoveState($item);
			});
		},

		_getSelectedFiles($item) {
			const $files = $item.find(selectors.resourceFile);
			const $selectedFiles = $files.filter(':checked');
			const ids = [];
			for (let i = 0; i < $selectedFiles.length; i++) {
				const $file = $selectedFiles.eq(i);
				const id = $file.val();
				ids.push(id);
			}
			return ids;
		},

		_getFilename($item) {
			const $name = $item.find(selectors.resourceTitle);
			const name = $name.text().trim();
			const $files = $item.find(selectors.resourceFile);
			const $selectedFiles = $files.filter(':checked');
			const $selectedFileContainers = $selectedFiles.closest(selectors.resourceFileContainer);
			const $selectedFileTypes = $selectedFileContainers.find(selectors.resourceFileType);
			const selectedFileTypes = [];
			for (let i = 0; i < $selectedFileTypes.length; i++) {
				const type = $selectedFileTypes.eq(i).text().trim();
				selectedFileTypes.push(type);
			}
			return name + ' ' + selectedFileTypes.join(', ') + '.zip';
		},

		_getMediaIdList(basket) {
			const mediaIds = [];
			for (let i = 0; i < basket.length; i++) {
				let id = basket[i];
				const idParts = id.match(/(.+)\|(.+)/);
				if (idParts) {
					mediaIds.push(idParts[2]);
				} else {
					mediaIds.push(id);
				}
			}
			return mediaIds;
		}
	}
};

export { module as basket };